<template>
  <el-dialog
    title="人员包片管理"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" :rules="rules">
        <el-form-item label="用户姓名" prop="userId">
          <el-select
            placeholder="用户姓名"
            clearable
            filterable
            v-model="formInline.userId"
            @change="configPageChange"
          >
            <el-option
              v-for="item in userListOptions"
              :key="item.id"
              :label="item.userName + '(' + item.deptName + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科室部门">
          <el-input
            v-model="userInfo.deptName"
            disabled
            style="width: 100%;"
            placeholder="科室部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="管辖部门">
          <el-select
            placeholder="管辖部门"
            clearable
            multiple
            v-model="formInline.deptIds"
          >
            <el-option
              v-for="item in deptIdsOptions"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="userConfigFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getPointLevelListPage, userConfig, configPage } from "@/api/point.js";
import { getUserList2 } from "@/api/systemManagement.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formInline: {
        userId: "",
        deptIds: []
      },
      userListOptions: [],
      deptIdsOptions: [],
      rules: {
        userId: [{ required: true, message: "请选择用户", trigger: "blur" }],
        deptIds: [
          { required: true, message: "请选择管辖部门", trigger: "blur" }
        ]
      },
      userInfo: {}
    };
  },
  mounted() {
    this.getUserList2PageFun();
    this.getPointLevelListPageFun();
  },
  methods: {
    configPageChange() {
      let userListOptions = JSON.parse(JSON.stringify(this.userListOptions));
      this.configPageFun();
      this.userInfo = userListOptions.find(
        item => item.id == this.formInline.userId
      );
    },
    // 分页查询
    async configPageFun() {
      let params = {
        userId: this.formInline.userId,
        page: 1,
        size: 99
      };
      const res = await configPage(params);
      if (res.data.code == 200) {
        if (res.data.data.records) {
          this.formInline.deptIds = res.data.data.records.map(
            item => item.deptId
          );
        }
      }
    },
    // 人员
    async getUserList2PageFun() {
      const res = await getUserList2({
        enableStatus: 0,
        page: 1,
        size: 9999,
        zcUserTypeLike: "gov"
      });
      this.userListOptions = res.data.data.dataList;
    },
    // 分页查询
    async getPointLevelListPageFun() {
      let params = {
        page: 1,
        size: 99999,
        levelCode: 2
      };
      const res = await getPointLevelListPage(params);
      this.deptIdsOptions = res.data.data.records || [];
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async userConfigFun() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      const res = await userConfig({
        userId: this.formInline.userId,
        deptIds: this.formInline.deptIds
      });

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}
/deep/.el-input__inner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/personBp/components/addDialog.vue